import { useCallback, useRef } from 'react';
import ClientInfo from '@pages/partners-registration/client-info/ClientInfo';
import ClientAddress from '@pages/partners-registration/client-address/ClientAddress';
import CompanyInfo from '@pages/partners-registration/company-info/CompanyInfo';
import SalesManInfo from '@pages/partners-registration/salesman-info/SalesManInfo';
import Message from '@pages/partners-registration/message/Message';
import Footer from '@pages/partners-registration/footer/Footer';


const PartnersRegistration = (): JSX.Element => {

	const formRef = useRef<HTMLDivElement | null>(null);

	const scrollToTop = useCallback(() => {
		formRef?.current?.scrollIntoView({ behavior: 'smooth' });
	},[ formRef ]);

	return (
		<div className="app-page partners-registration-page" ref={formRef}>
			
			<h1>Registrační formulář</h1>

			<div className='intro-text'>
				<p>Chcete se dozvědět více o našich produktech? Zajímá Vás ceník pro&nbsp;vaši ordinaci nebo jiné produktové informace? Máte zájem o spolupráci? Nechte nám na&nbsp;sebe kontakt, rádi se ozveme!</p>
			</div>

			<ClientInfo />

			<ClientAddress />

			<CompanyInfo />

			<SalesManInfo />

			<Message />

			<Footer scrollToTop={scrollToTop} />

		</div>
	);
};

export default PartnersRegistration;